// import React, { useEffect, useState } from "react";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { Formik, Form, Field, ErrorMessage } from "formik";
// import Button from "../../utils/Buttons";
// import { dropdownCategories } from "../../api/dropdownService";

// /* ---------- IMAGE TO BASE64 ---------- */
// const toBase64 = (file) =>
//   new Promise((resolve, reject) => {
//     const reader = new FileReader();

//     reader.readAsDataURL(file);

//     reader.onload = () => resolve(reader.result);
//     reader.onerror = reject;
//   });

// const ALLOWED_IMAGE_TYPES = ["image/png", "image/jpeg", "image/jpg"];

// const PostTemplateForm = ({
//   initialValues,
//   onSubmit,
//   loading = false,
//   message,
//   onCancel,
//   isEdit = false,
// }) => {
//   const [showCancelModal, setShowCancelModal] = useState(false);
//   const [showSuccessModal, setShowSuccessModal] = useState(false);

//   const [categories, setCategories] = useState([]);
//   const [categoryLoading, setCategoryLoading] = useState(false);

//   /* ---------- GET CATEGORIES ---------- */
//   useEffect(() => {
//     fetchCategories();
//   }, []);

//   const fetchCategories = async () => {
//     try {
//       setCategoryLoading(true);

//       const response = await dropdownCategories();

//       console.log("Category Dropdown Response:", response);

//       /*
//        * Adjust this depending on your API response.
//        *
//        * Supports:
//        * response.data
//        * response.data.categories
//        * response.categories
//        */
//       const categoryList =
//         response?.data?.categories ||
//         response?.data ||
//         response?.categories ||
//         [];

//       setCategories(Array.isArray(categoryList) ? categoryList : []);
//     } catch (error) {
//       console.error("Failed to fetch categories:", error);

//       setCategories([]);
//     } finally {
//       setCategoryLoading(false);
//     }
//   };

//   /* ---------- OPEN SUCCESS MODAL ON MESSAGE ---------- */
//   useEffect(() => {
//     if (message) {
//       setShowSuccessModal(true);
//     }
//   }, [message]);

//   /* ---------- VALIDATION ---------- */
//   const validate = (values) => {
//     const errors = {};

//     if (!values.name?.trim()) {
//       errors.name = "Post Template Name is required";
//     }

//     if (!values.fromDate) {
//       errors.fromDate = "From Date is required";
//     }

//     if (!values.toDate) {
//       errors.toDate = "To Date is required";
//     }

//     if (
//       values.fromDate &&
//       values.toDate &&
//       new Date(values.fromDate) > new Date(values.toDate)
//     ) {
//       errors.toDate = "To Date must be greater than From Date";
//     }

//     if (!values.categoryId) {
//       errors.categoryId = "Category is required";
//     }

//     if (!values.status) {
//       errors.status = "Status is required";
//     }

//     if (!values.description?.trim()) {
//       errors.description = "Description is required";
//     }

//     if (!values.link?.trim()) {
//       errors.link = "Link is required";
//     }

//     if (!isEdit && !values.image) {
//       errors.image = "Image is required";
//     }

//     return errors;
//   };

//   return (
//     <>
//       <div className="container mt-3">
//         <div className="card-header">
//           <h4>{isEdit ? "Edit Banner Template" : "Add New Banner Template"}</h4>
//         </div>

//         <Formik
//           enableReinitialize
//           initialValues={{
//             name: initialValues?.name || "",

//             fromDate: initialValues?.fromDate || "",

//             toDate: initialValues?.toDate || "",

//             categoryId: initialValues?.categoryId || "",

//             status: initialValues?.status || "ACTIVE",

//             description: initialValues?.description || "",

//             link: initialValues?.link || "",

//             image: initialValues?.image || "",
//             newImage: "",
//           }}
//           validate={validate}
//           onSubmit={async (values, { setSubmitting, setErrors }) => {
//             const formatDate = (date) => {
//               if (!date) return "";

//               if (typeof date === "string") {
//                 return date.split("T")[0];
//               }

//               return date.toISOString().split("T")[0];
//             };

//             const payload = {
//               name: values.name.trim(),
//               fromDate: formatDate(values.fromDate),
//               toDate: formatDate(values.toDate),
//               status: values.status.toUpperCase(),
//               categoryId: values.categoryId,
//               description: values.description.trim(),
//               link: values.link.trim(),
//             };

//             /*
//              * ADD:
//              * Always send the newly selected image.
//              */
//             if (!isEdit) {
//               payload.image = values.newImage || values.image;
//             }

//             /*
//              * EDIT:
//              * Only send image if user selected a new image.
//              */
//             if (isEdit && values.newImage) {
//               payload.image = values.newImage;
//             }

//             try {
//               await onSubmit(payload, setErrors);
//             } finally {
//               setSubmitting(false);
//             }
//           }}
//         >
//           {({
//             isSubmitting,
//             setFieldValue,
//             setFieldError,
//             setFieldTouched,
//             values,
//             resetForm,
//           }) => (
//             <Form>
//               <div className="card">
//                 <div className="card-body">
//                   {/* ---------- NAME ---------- */}
//                   <div className="mb-3">
//                     <label className="form-label">
//                       Banner Template Name
//                       <span className="error">*</span>
//                     </label>

//                     <Field
//                       name="name"
//                       maxLength={50}
//                       className="form-control"
//                       placeholder="Enter banner template name"
//                     />

//                     <ErrorMessage
//                       name="name"
//                       component="div"
//                       className="error small"
//                     />
//                   </div>

//                   {/* ---------- ROW ---------- */}
//                   <div className="row">
//                     {/* ---------- FROM DATE ---------- */}
//                     <div className="col-md-3 mb-3">
//                       <label className="form-label">
//                         From Date
//                         <span className="error">*</span>
//                       </label>

//                       <DatePicker
//                         className="form-control"
//                         selected={
//                           values.fromDate ? new Date(values.fromDate) : null
//                         }
//                         onChange={(date) => {
//                           setFieldValue("fromDate", date);

//                           setFieldTouched("fromDate", true);
//                         }}
//                         dateFormat="yyyy-MM-dd"
//                         showIcon
//                         placeholderText="Select from date"
//                       />

//                       <ErrorMessage
//                         name="fromDate"
//                         component="div"
//                         className="error small"
//                       />
//                     </div>

//                     {/* ---------- TO DATE ---------- */}
//                     <div className="col-md-3 mb-3">
//                       <label className="form-label">
//                         To Date
//                         <span className="error">*</span>
//                       </label>

//                       <DatePicker
//                         className="form-control"
//                         selected={
//                           values.toDate ? new Date(values.toDate) : null
//                         }
//                         onChange={(date) => {
//                           setFieldValue("toDate", date);

//                           setFieldTouched("toDate", true);
//                         }}
//                         dateFormat="yyyy-MM-dd"
//                         showIcon
//                         placeholderText="Select to date"
//                       />

//                       <ErrorMessage
//                         name="toDate"
//                         component="div"
//                         className="error small"
//                       />
//                     </div>

//                     {/* ---------- CATEGORY ---------- */}
//                     <div className="col-md-3 mb-3">
//                       <label className="form-label">
//                         Category<span className="error">*</span>
//                       </label>

//                       <Field
//                         as="select"
//                         name="categoryId"
//                         className="form-select"
//                         disabled={categoryLoading}
//                       >
//                         <option value="">
//                           {categoryLoading
//                             ? "Loading categories..."
//                             : "Select Category"}
//                         </option>

//                         {categories.map((category) => (
//                           <option key={category._id} value={category._id}>
//                             {category.name}
//                           </option>
//                         ))}
//                       </Field>

//                       <ErrorMessage
//                         name="categoryId"
//                         component="div"
//                         className="error small"
//                       />
//                     </div>

//                     {/* ---------- STATUS ---------- */}
//                     <div className="col-md-3 mb-3">
//                       <label className="form-label">
//                         Status
//                         <span className="error">*</span>
//                       </label>

//                       <Field as="select" name="status" className="form-select">
//                         <option value="ACTIVE">ACTIVE</option>

//                         <option value="INACTIVE">INACTIVE</option>
//                       </Field>

//                       <ErrorMessage
//                         name="status"
//                         component="div"
//                         className="error small"
//                       />
//                     </div>
//                   </div>

//                   {/* ---------- DESCRIPTION ---------- */}
//                   <div className="mb-3">
//                     <label className="form-label">
//                       Description
//                       <span className="error">*</span>
//                     </label>

//                     <Field
//                       as="textarea"
//                       name="description"
//                       rows="4"
//                       className="form-control"
//                       placeholder="Enter description"
//                     />

//                     <ErrorMessage
//                       name="description"
//                       component="div"
//                       className="error small"
//                     />
//                   </div>

//                   {/* ---------- LINK ---------- */}
//                   <div className="mb-3">
//                     <label className="form-label">
//                       Link<span className="error">*</span>
//                     </label>

//                     <Field
//                       type="url"
//                       name="link"
//                       className="form-control"
//                       placeholder="https://example.com"
//                     />

//                     <ErrorMessage
//                       name="link"
//                       component="div"
//                       className="error small"
//                     />
//                   </div>

//                   {/* ---------- IMAGE ---------- */}
//                   <div className="mb-3 col-md-6">
//                     <label className="form-label">
//                       {isEdit ? "Change Image" : "Choose Image"}
//                       {!isEdit && <span className="error">*</span>}
//                     </label>

//                     <input
//                       type="file"
//                       className="form-control"
//                       accept=".png,.jpg,.jpeg,.webp"
//                       onChange={async (e) => {
//                         const file = e.target.files?.[0];

//                         if (!file) return;

//                         if (
//                           ![
//                             "image/png",
//                             "image/jpeg",
//                             "image/jpg",
//                             "image/webp",
//                           ].includes(file.type)
//                         ) {
//                           setFieldError(
//                             "newImage",
//                             "Only PNG, JPG, JPEG, WEBP allowed",
//                           );
//                           return;
//                         }

//                         try {
//                           const base64 = await toBase64(file);

//                           // New image for API
//                           setFieldValue("newImage", base64);

//                           // Preview selected image
//                           setFieldValue("image", base64);

//                           setFieldTouched("newImage", true);
//                           setFieldError("newImage", "");
//                         } catch (error) {
//                           console.error(error);
//                           setFieldError("newImage", "Failed to process image");
//                         }
//                       }}
//                     />

//                     <ErrorMessage
//                       name="newImage"
//                       component="div"
//                       className="error small"
//                     />
//                   </div>

//                   {/* ---------- IMAGE PREVIEW ---------- */}
//                   {values.image && (
//                     <div className="mb-3">
//                       <label className="form-label d-block">
//                         Image Preview
//                       </label>

//                       <img
//                         src={values.image}
//                         alt="Preview"
//                         height={120}
//                         className="rounded border"
//                       />
//                     </div>
//                   )}
//                 </div>

//                 {/* ---------- FOOTER ---------- */}
//                 <div className="card-footer text-end">
//                   <Button
//                     type="submit"
//                     text={
//                       loading
//                         ? "Processing..."
//                         : isEdit
//                           ? "Update Template"
//                           : "Submit"
//                     }
//                     className="btn btn-primary m-2"
//                     disabled={loading || isSubmitting}
//                   />

//                   <Button
//                     text="Cancel"
//                     type="button"
//                     className="btn btn-outline-danger m-2"
//                     onClick={() => setShowCancelModal(true)}
//                     disabled={loading}
//                   />
//                 </div>
//               </div>

//               {/* ---------- CANCEL MODAL ---------- */}
//               {showCancelModal && (
//                 <div className="modal fade show d-block" style={styles.modalBg}>
//                   <div className="modal-dialog modal-dialog-centered">
//                     <div className="modal-content">
//                       <div className="modal-header">
//                         <h5 className="modal-title">Confirm Action</h5>

//                         <button
//                           type="button"
//                           className="btn-close"
//                           onClick={() => setShowCancelModal(false)}
//                         />
//                       </div>

//                       <div className="modal-body">
//                         Are you sure, want to go back?
//                       </div>

//                       <div className="modal-footer">
//                         <Button
//                           text="Confirm"
//                           type="button"
//                           className="btn btn-secondary"
//                           onClick={() => {
//                             resetForm();

//                             setShowCancelModal(false);

//                             onCancel && onCancel();
//                           }}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* ---------- SUCCESS MODAL ---------- */}
//               {showSuccessModal && (
//                 <div className="modal fade show d-block" style={styles.modalBg}>
//                   <div className="modal-dialog modal-dialog-centered">
//                     <div className="modal-content">
//                       <div className="modal-header bg-success text-white">
//                         <h5 className="modal-title">Success</h5>
//                       </div>

//                       <div className="modal-body text-center">
//                         <p>{message}</p>
//                       </div>

//                       <div className="modal-footer justify-content-center">
//                         <Button
//                           text="OK"
//                           type="button"
//                           className="btn btn-success"
//                           onClick={() => {
//                             setShowSuccessModal(false);

//                             onCancel && onCancel();
//                           }}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </Form>
//           )}
//         </Formik>
//       </div>
//     </>
//   );
// };

// /* ---------- STYLES ---------- */
// const styles = {
//   loaderOverlay: {
//     position: "fixed",
//     inset: 0,
//     backgroundColor: "rgba(0,0,0,0.6)",
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     justifyContent: "center",
//     zIndex: 9999,
//   },

//   modalBg: {
//     backgroundColor: "rgba(0,0,0,0.6)",
//   },
// };

// export default PostTemplateForm;

import React, { useEffect, useState } from "react";
import StatusDropdown from "../Shared/StatusDropdown";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Button from "../../utils/Buttons";
import { dropdownCategories } from "../../api/dropdownService";

/* ---------- IMAGE TO BASE64 ---------- */
const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });

const ALLOWED_IMAGE_TYPES = ["image/png", "image/jpeg", "image/jpg"];

const PostTemplateForm = ({
  initialValues,
  onSubmit,
  loading = false,
  message,
  onCancel,
  isEdit = false,
}) => {
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const [categories, setCategories] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(false);

  /* ---------- GET CATEGORIES ---------- */
  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      setCategoryLoading(true);

      const response = await dropdownCategories();
      const categoryList =
        response?.data?.categories || response?.data || response?.categories || [];

      setCategories(Array.isArray(categoryList) ? categoryList : []);
    } catch (error) {
      console.error("Failed to fetch categories:", error);

      setCategories([]);
    } finally {
      setCategoryLoading(false);
    }
  };

  /* ---------- OPEN SUCCESS MODAL ON MESSAGE ---------- */
  useEffect(() => {
    if (message) {
      setShowSuccessModal(true);
    }
  }, [message]);

  /* ---------- VALIDATION ---------- */
  const validate = (values) => {
    const errors = {};

    if (!values.name?.trim()) {
      errors.name = "Post Template Name is required";
    }

    if (!values.fromDate) {
      errors.fromDate = "From Date is required";
    }

    if (!values.toDate) {
      errors.toDate = "To Date is required";
    }

    if (values.fromDate && values.toDate && new Date(values.fromDate) > new Date(values.toDate)) {
      errors.toDate = "To Date must be greater than From Date";
    }

    if (!values.categoryId) {
      errors.categoryId = "Category is required";
    }

    if (!values.status) {
      errors.status = "Status is required";
    }

    if (!values.description?.trim()) {
      errors.description = "Description is required";
    }

    if (!values.link?.trim()) {
      errors.link = "Link is required";
    }

    if (!values.orderId && values.orderId !== 0) {
      errors.orderId = "Order ID is required";
    }

    if (values.orderId !== "" && Number(values.orderId) < 0) {
      errors.orderId = "Order ID must be a valid number";
    }

    if (!isEdit && !values.image) {
      errors.image = "Image is required";
    }

    return errors;
  };

  return (
    <>
      <div className="container mt-3">
        <Formik
          enableReinitialize
          initialValues={{
            name: initialValues?.name || "",

            fromDate: initialValues?.fromDate || "",

            toDate: initialValues?.toDate || "",

            categoryId: initialValues?.categoryId || "",

            status: initialValues?.status || "ACTIVE",

            description: initialValues?.description || "",

            link: initialValues?.link || "",

            // Added Order ID
            orderId: initialValues?.orderId ?? "",

            image: initialValues?.image || "",

            newImage: "",
          }}
          validate={validate}
          onSubmit={async (values, { setSubmitting, setErrors }) => {
            const formatDate = (date) => {
              if (!date) return "";

              if (typeof date === "string") {
                return date.split("T")[0];
              }

              return date.toISOString().split("T")[0];
            };

            const payload = {
              name: values.name.trim(),
              fromDate: formatDate(values.fromDate),
              toDate: formatDate(values.toDate),
              status: values.status.toUpperCase(),

              // Added Order ID
              orderId: Number(values.orderId),

              categoryId: values.categoryId,
              description: values.description.trim(),
              link: values.link.trim(),
            };

            /*
             * ADD:
             * Always send the newly selected image.
             */
            if (!isEdit) {
              payload.image = values.newImage || values.image;
            }

            // The edit endpoint requires an image on every request.
            if (isEdit) {
              payload.image = values.newImage || values.image;
            }

            try {
              await onSubmit(payload, setErrors);
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {({ isSubmitting, setFieldValue, setFieldError, setFieldTouched, values, resetForm }) => (
            <Form>
              <div className="card">
                <div className="card-header">
                  <h4>{isEdit ? "Edit Banner Template" : "Add New Banner Template"}</h4>
                </div>
                <div className="card-body">
                  {/* ---------- NAME ---------- */}
                  <div className="mb-3">
                    <label className="form-label">
                      Banner Template Name
                      <span className="error">*</span>
                    </label>

                    <Field
                      name="name"
                      maxLength={50}
                      className="form-control"
                      placeholder="Enter banner template name"
                    />

                    <ErrorMessage name="name" component="div" className="error small" />
                  </div>

                  {/* ---------- ROW ---------- */}
                  <div className="row">
                    {/* ---------- FROM DATE ---------- */}
                    <div className="col-md-3 mb-3">
                      <label className="form-label">
                        From Date
                        <span className="error">*</span>
                      </label>

                      <DatePicker
                        className="form-control"
                        selected={values.fromDate ? new Date(values.fromDate) : null}
                        onChange={(date) => {
                          setFieldValue("fromDate", date);

                          setFieldTouched("fromDate", true);
                        }}
                        dateFormat="yyyy-MM-dd"
                        showIcon
                        placeholderText="Select from date"
                      />

                      <ErrorMessage name="fromDate" component="div" className="error small" />
                    </div>

                    {/* ---------- TO DATE ---------- */}
                    <div className="col-md-3 mb-3">
                      <label className="form-label">
                        To Date
                        <span className="error">*</span>
                      </label>

                      <DatePicker
                        className="form-control"
                        selected={values.toDate ? new Date(values.toDate) : null}
                        onChange={(date) => {
                          setFieldValue("toDate", date);

                          setFieldTouched("toDate", true);
                        }}
                        dateFormat="yyyy-MM-dd"
                        showIcon
                        placeholderText="Select to date"
                      />

                      <ErrorMessage name="toDate" component="div" className="error small" />
                    </div>

                    {/* ---------- CATEGORY ---------- */}
                    <div className="col-md-3 mb-3">
                      <label className="form-label">
                        Category<span className="error">*</span>
                      </label>

                      <Field
                        as="select"
                        name="categoryId"
                        className="form-select"
                        disabled={categoryLoading}
                      >
                        <option value="">
                          {categoryLoading ? "Loading categories..." : "Select Category"}
                        </option>

                        {categories.map((category) => (
                          <option key={category._id} value={category._id}>
                            {category.name}
                          </option>
                        ))}
                      </Field>

                      <ErrorMessage name="categoryId" component="div" className="error small" />
                    </div>

                    {/* ---------- STATUS ---------- */}
                    <div className="col-md-3 mb-3">
                      <label className="form-label">
                        Status
                        <span className="error">*</span>
                      </label>

                      <Field as={StatusDropdown} name="status" className="form-select" activeLabel="ACTIVE" inactiveLabel="INACTIVE" />

                      <ErrorMessage name="status" component="div" className="error small" />
                    </div>
                  </div>

                  {/* ---------- ORDER ID ---------- */}
                  <div className="row">
                    <div className="col-md-3 mb-3">
                      <label className="form-label">
                        Order ID
                        <span className="error">*</span>
                      </label>

                      <Field
                        type="number"
                        name="orderId"
                        className="form-control"
                        placeholder="Enter order ID"
                        min="0"
                      />

                      <ErrorMessage name="orderId" component="div" className="error small" />
                    </div>
                  </div>

                  {/* ---------- DESCRIPTION ---------- */}
                  <div className="mb-3">
                    <label className="form-label">
                      Description
                      <span className="error">*</span>
                    </label>

                    <Field
                      as="textarea"
                      name="description"
                      rows="4"
                      className="form-control"
                      placeholder="Enter description"
                    />

                    <ErrorMessage name="description" component="div" className="error small" />
                  </div>

                  {/* ---------- LINK ---------- */}
                  <div className="mb-3">
                    <label className="form-label">
                      Link<span className="error">*</span>
                    </label>

                    <Field
                      type="url"
                      name="link"
                      className="form-control"
                      placeholder="https://example.com"
                    />

                    <ErrorMessage name="link" component="div" className="error small" />
                  </div>

                  {/* ---------- IMAGE ---------- */}
                  <div className="mb-3 col-md-6">
                    <label className="form-label">
                      {isEdit ? "Change Image" : "Choose Image"}
                      {!isEdit && <span className="error">*</span>}
                    </label>

                    <input
                      type="file"
                      className="form-control"
                      accept=".png,.jpg,.jpeg,.webp"
                      onChange={async (e) => {
                        const file = e.target.files?.[0];

                        if (!file) return;

                        if (
                          !["image/png", "image/jpeg", "image/jpg", "image/webp"].includes(
                            file.type,
                          )
                        ) {
                          setFieldError("newImage", "Only PNG, JPG, JPEG, WEBP allowed");
                          return;
                        }

                        try {
                          const base64 = await toBase64(file);

                          // New image for API
                          setFieldValue("newImage", base64);

                          // Preview selected image
                          setFieldValue("image", base64);

                          setFieldTouched("newImage", true);
                          setFieldError("newImage", "");
                        } catch (error) {
                          console.error(error);
                          setFieldError("newImage", "Failed to process image");
                        }
                      }}
                    />

                    <ErrorMessage name="newImage" component="div" className="error small" />
                  </div>

                  {/* ---------- IMAGE PREVIEW ---------- */}
                  {values.image && (
                    <div className="mb-3">
                      <label className="form-label d-block">Image Preview</label>

                      <img
                        src={values.image}
                        alt="Preview"
                        height={120}
                        className="rounded border"
                      />
                    </div>
                  )}
                </div>

                {/* ---------- FOOTER ---------- */}
                <div className="card-footer text-end">
                  <Button
                    type="submit"
                    text={loading ? "Processing..." : isEdit ? "Update Template" : "Submit"}
                    className="btn btn-primary m-2"
                    disabled={loading || isSubmitting}
                  />

                  <button
                    type="button"
                    className="btn"
                    style={{ backgroundColor: "#032B4D", color: "#fff" }}
                    onClick={() => setShowCancelModal(true)}
                    disabled={loading}
                  >
                    Cancel
                  </button>
                </div>
              </div>

              {/* ---------- CANCEL MODAL ---------- */}
              {showCancelModal && (
                <div className="modal fade show d-block" style={styles.modalBg}>
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Confirm Action</h5>

                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => setShowCancelModal(false)}
                        />
                      </div>

                      <div className="modal-body">Are you sure, want to go back?</div>

                      <div className="modal-footer">
                        <Button
                          text="Confirm"
                          type="button"
                          className="btn btn-success"
                          onClick={() => {
                            resetForm();

                            setShowCancelModal(false);

                            onCancel && onCancel();
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* ---------- SUCCESS MODAL ---------- */}
              {showSuccessModal && (
                <div className="modal fade show d-block" style={styles.modalBg}>
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header bg-success text-white">
                        <h5 className="modal-title">Success</h5>
                      </div>

                      <div className="modal-body text-center">
                        <p>{message}</p>
                      </div>

                      <div className="modal-footer justify-content-center">
                        <Button
                          text="OK"
                          type="button"
                          className="btn btn-success"
                          onClick={() => {
                            setShowSuccessModal(false);

                            onCancel && onCancel();
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

/* ---------- STYLES ---------- */
const styles = {
  loaderOverlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.6)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },

  modalBg: {
    backgroundColor: "rgba(0,0,0,0.6)",
  },
};

export default PostTemplateForm;
